import { render, staticRenderFns } from "./PropanLogo.vue?vue&type=template&id=10a2ece8&scoped=true"
import script from "./PropanLogo.vue?vue&type=script&lang=js"
export * from "./PropanLogo.vue?vue&type=script&lang=js"
import style0 from "./PropanLogo.vue?vue&type=style&index=0&id=10a2ece8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a2ece8",
  null
  
)

export default component.exports